/**
 * Unveil (conductor)
 *
 * Facilitates unveil animations on initial image loaded / restore from cache.
 * Adds a class 'is-loaded' to elements with the [data-unveil] attribute
 * when all images matching a selector, or images nested inside, are loaded.
 */

export default class Unveil {

    images = [];

    constructor(elm) {
        const veils = document.querySelectorAll(elm + ':not(.is-loaded)');
        veils.forEach((veil) => {
            if (veil.dataset.unveil) {
                // wait for any image(s) matching the given selector
                this.images = document.querySelectorAll(veil.dataset.unveil);
            } else {
                if (veil.tagName === 'IMG') {
                    // wait for self to load if it's an image
                    this.images = [veil];
                } else {
                    // or, wait for any image(s) found inside the veil
                    this.images = veil.querySelectorAll('img');
                }
            }
            if (this.images) {
                this.waitForAllImages().then(() => {
                    veil.classList.add('is-loaded');
                    veil = null;
                });
            }
        });
    }

    waitForAllImages() {
        let promises = [];
        this.images.forEach((img) => {
            promises.push(this.waitForImage(img));
        });
        return new Promise((resolve) => {
            Promise.all(promises).then(() => {
                resolve();
            });
        });
    }

    waitForImage(img) {
        return new Promise((resolve) => {
            if (img.complete && img.naturalWidth > 0) {
                // cached image
                resolve();
            } else {
                img.loadHandler = (e) => {
                    img.removeEventListener('load', img.loadHandler);
                    img.removeEventListener('error', img.loadHandler);
                    img.removeEventListener('lazybeforeunveil', img.loadHandler);
                    resolve();
                };
                // resolve on load or error
                img.addEventListener('load', img.loadHandler);
                img.addEventListener('error', img.loadHandler);

                // lazyloaded image
                // => requires lazysizes: https://github.com/aFarkas/lazysizes)
                img.addEventListener('lazybeforeunveil', img.loadHandler);
            }
        });
    }
}